import { ENDPOINTS } from "@/api/routing";

import { getAxiosConfig } from "@/services/axiosConfig";
import { Design, GenericLogo } from "@/types/ui.types";
import { Data } from "@/types/all.types";

export const design = {
  getStickers: async () => {
    const res = await getAxiosConfig().get<Design[]>(ENDPOINTS.GET_STICKERS());
    return res.data;
  },
  getStyles: async () => {
    const res = await getAxiosConfig().get<Design[]>(ENDPOINTS.GET_STYLES());
    return res.data;
  },
  getPatterns: async () => {
    const res = await getAxiosConfig().get<Design[]>(ENDPOINTS.GET_PATTERNS());
    return res.data;
  },
  getMakeBorders: async () => {
    const res = await getAxiosConfig().get<Design[]>(ENDPOINTS.GET_MAKE_BORDERS());
    return res.data;
  },
  getLogo: async () => {
    const res = await getAxiosConfig().get<Data<GenericLogo[]>>(ENDPOINTS.GET_LOGO());
    return res.data;
  },
  resetLogo: async () => {
    const res = await getAxiosConfig().get<Data<GenericLogo[]>>(ENDPOINTS.RESET_LOGO());
    return res.data;
  },
  deleteLogo: async (uuid: string) => {
    const res = await getAxiosConfig().delete<Data<GenericLogo[]>>(ENDPOINTS.DELETE_LOGO(uuid));
    return res.data;
  },
  postUpdateLogo: async (params: string) => {
    const res = await getAxiosConfig().post<Data<GenericLogo>>(ENDPOINTS.UPDATE_LOGO(), params);
    return res.data;
  },
};
